module.exports = __webpack_public_path__ + "static/media/down-chevron.8e65701e.svg";